<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12">
    <app-status-select-field
      formControlName="problemStatus"
      [label]="'problemRecord.fields.problemStatus.label' | translate"
      [items]="statusItems"
      [bindValue]="'value'"
      [customClass]="'case-right-section'"
      [isDisabledField]="true"
      [itemClass]="form.get('problemStatus')?.value"
    ></app-status-select-field>
  </div>
  <div class="col-12">
    <app-severity-select-field
      formControlName="problemPriority"
      [label]="'problemRecord.fields.problemPriority.label' | translate"
      [placeholder]="'placeholders.please_select'"
      [items]="problemPriorityItems"
      [optionItem]="'name'"
      [bindValue]="'value'"
      [customClass]="'case-right-section'"
    ></app-severity-select-field>
  </div>
  <div class="col-12">
    <app-datepicker-form-field
      formControlName="verifyDate"
      [label]="'problemRecord.fields.verifyDate.label' | translate"
      [viewMode]="viewMode"
    ></app-datepicker-form-field>
  </div>
  <div class="col-12">
    <app-datepicker-form-field
      formControlName="closedDate"
      [label]="'problemRecord.fields.closedDate.label' | translate"
      [viewMode]="viewMode"
    ></app-datepicker-form-field>
  </div>
</div>
